<template>
  <div class="register absolute">
    <div class="logo_title">
      Hi,我将陪伴您每一天
    </div>
    <div
      class="acea-row row-around row-center"
      style="margin-bottom: 15px;font-size: 16px;color: #626976;"
    >
      <div
        :class="formItem == 1 ? 'som' : ''"
        style="font-weight: bold;"
        @click="formItem = 1"
      >
        登录
      </div>
      <div
        :class="formItem == 2 ? 'som' : ''"
        style="font-weight: bold;"
        @click="formItem = 2"
      >
        注册
      </div>
    </div>
    <div class="whiteBg" v-if="formItem === 1">
      <div class="list" :hidden="current !== 0">
        <form @submit.prevent="submit">
          <div class="item">
            <div class="acea-row">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-phone_"></use>
              </svg>
              <div class="item_name">
                手机号
              </div>
            </div>
            <div class="inp_box">
              <input
                type="text"
                placeholder="输入手机号码"
                v-model="account"
                required
              />
            </div>
          </div>
          <div class="item">
            <div class="acea-row">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-code_"></use>
              </svg>
              <div class="item_name">
                登录密码
              </div>
            </div>
            <div class="inp_box">
              <input
                type="password"
                placeholder="填写登录密码"
                v-model="password"
                required
              />
            </div>
          </div>
        </form>
        <div class="acea-row row-between row-middle">
          <div class="forgetPwd" @click="current = 1">
            验证码登录
          </div>
          <div
            class="forgetPwd"
            @click="$router.push({ name: 'RetrievePassword' })"
          >
            <span class="iconfont icon-wenti"></span>忘记密码
          </div>
        </div>
      </div>
      <div class="list" :hidden="current !== 1">
        <div class="item">
          <div class="acea-row">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-phone_"></use>
            </svg>
            <div class="item_name">
              手机号
            </div>
          </div>
          <div class="inp_box">
            <input
              type="text"
              placeholder="输入手机号码"
              v-model="account"
              required
            />
          </div>
        </div>
        <div class="item">
          <div class="acea-row">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_1"></use>
            </svg>
            <div class="item_name">
              验证码
            </div>
          </div>
          <div class="inp_box acea-row row-between row-middle">
            <input
              type="text"
              placeholder="填写验证码"
              class="codeIput"
              v-model="captcha"
            />
            <button
              class="code"
              :disabled="disabled"
              :class="disabled === true ? 'on' : ''"
              @click="code"
            >
              {{ text }}
            </button>
          </div>
        </div>
        <div class="item" v-if="isShowCode">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg>
            <input
              type="text"
              placeholder="填写验证码"
              class="codeIput"
              v-model="codeVal"
            />
            <div class="code" @click="again"><img :src="codeUrl" /></div>
          </div>
        </div>
        <div class="acea-row row-between row-middle">
          <div class="forgetPwd" @click="current = 0">
            密码登录
          </div>
        </div>
      </div>

      <div class="logon" @click="loginMobile" :hidden="current !== 1">登录</div>
      <div class="logon" @click="submit" :hidden="current === 1">登录</div>
      <!-- <div class="tip">
        没有账号?
        <span @click="formItem = 2" class="font-color-red">立即注册</span>
      </div> -->
    </div>
    <div class="whiteBg" v-else>
      <div class="title">注册账号</div>
      <div class="list">
        <div class="item">
          <div class="acea-row">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-phone_"></use>
            </svg>
            <div class="item_name">
              手机号
            </div>
          </div>
          <div class="inp_box">
            <input
              type="text"
              placeholder="输入手机号码"
              v-model="account"
              @blur="onSmsCaptcha"
              required
            />
          </div>
        </div>
        <div class="item">
          <div class="acea-row">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_1"></use>
            </svg>
            <div class="item_name">
              验证码
            </div>
          </div>
          <div class="inp_img acea-row row-between row-middle">
            <input
              type="text"
              placeholder="填写验证码"
              class="codeIput"
              v-model="captcha"
            />
            <div @click="onSmsCaptcha">
              <img v-if="codeUrl" :src="codeUrl" class="code_img" mode="" />
              <div class="code_img" v-else></div>
            </div>
            <!-- <button
              class="code"
              :disabled="disabled"
              :class="disabled === true ? 'on' : ''"
              @click="code"
            >
              {{ text }}
            </button> -->
          </div>
        </div>
        <div class="list">
          <div class="item">
            <div class="acea-row">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-code_"></use>
              </svg>
              <div class="item_name">
                邀请码
              </div>
            </div>
            <div class="inp_box">
              <input type="text" placeholder="填写邀请码" v-model="spread" />
            </div>
          </div>
          <div class="item">
            <div class="acea-row">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-code_"></use>
              </svg>
              <div class="item_name">
                登录密码
              </div>
            </div>
            <div class="inp_box">
              <input
                type="password"
                placeholder="填写您的登录密码"
                v-model="password"
              />
            </div>
          </div>
          <div class="item" v-if="isShowCode">
            <div class="acea-row">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#code_"></use>
              </svg>
              <div class="item_name">
                验证码
              </div>
            </div>
            <div class="inp_box acea-row row-between row-middle">
              <input
                type="text"
                placeholder="填写验证码"
                class="codeIput"
                v-model="codeVal"
              />
              <div class="code" @click="again"><img :src="codeUrl" /></div>
            </div>
          </div>
        </div>
      </div>
      <div class="logon" @click="register">注册</div>
      <!-- <div class="tip">
        已有账号?
        <span @click="formItem = 1" class="font-color-red">立即登录</span>
      </div> -->
    </div>
    <!-- <div class="bottom"></div> -->
  </div>
</template>
<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import {
  login,
  loginMobile,
  registerVerify,
  register,
  getCodeApi
} from "@api/user";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { getLogo } from "@api/public";
import cookie from "@utils/store/cookie";
import { VUE_APP_API_URL, isWeixin, parseQuery } from "@utils";
import { oAuth } from "@libs/wechat";
const BACK_URL = "login_back_url";
const SPREAD = "spread";
export default {
  name: "Login",
  mixins: [sendVerifyCode],
  data: function() {
    return {
      navList: ["账号登录", "快速登录"],
      current: 0,
      account: "",
      password: "",
      captcha: "",
      formItem: 1,
      spread: cookie.get(SPREAD),
      type: "login",
      logoUrl: "",
      keyCode: "",
      codeUrl: "",
      codeVal: "",
      isShowCode: false,
      wxcode: ""
    };
  },
  mounted: function() {
    if (isWeixin() && !this.$route.query.type) {
      oAuth();
      let { code } = parseQuery();
      this.wxcode = code;
    }
    if (this.$route.query.spread) {
      this.spread = this.$route.query.spread;
      this.formItem = 2;
    }
    this.getCode();
    this.getLogoImage();
  },

  methods: {
    async onSmsCaptcha() {
      var that = this;
      const { account } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({
            account
          });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      const num = Math.random() * 100;
      this.codeUrl = `${VUE_APP_API_URL}/sms_captcha?key=${
        this.account
      }&=${num}`;
    },
    again() {
      this.codeUrl =
        VUE_APP_API_URL +
        "/sms_captcha?" +
        "key=" +
        this.keyCode +
        Date.parse(new Date());
    },
    getCode() {
      getCodeApi()
        .then(res => {
          this.keyCode = res.data.key;
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
    async getLogoImage() {
      let that = this;
      getLogo(2).then(res => {
        that.logoUrl = res.data.logo_url;
      });
    },
    async loginMobile() {
      var that = this;
      const { account, captcha } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ]
          })
          .validate({
            account,
            captcha
          });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      loginMobile({
        phone: that.account,
        captcha: that.captcha,
        spread: cookie.get("spread")
      })
        .then(res => {
          let data = res.data;
          let expires_time = data.expires_time.substring(0, 19);
          expires_time = expires_time.replace(/-/g, "/");
          expires_time = new Date(expires_time).getTime() - 28800000;
          const datas = {
            token: data.token,
            expires_time: expires_time
          };
          that.$store.commit("LOGIN", datas);
          // let newTime = Math.round(new Date() / 1000);
          const backUrl = cookie.get(BACK_URL) || "/";
          cookie.remove(BACK_URL);
          that.$router.replace({
            path: backUrl
          });
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    async register() {
      var that = this;
      const { account, captcha, password } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ],
            password: [
              required(required.message("密码")),
              attrs.range([6, 16], attrs.range.message("密码")),
              alpha_num(alpha_num.message("密码"))
            ]
          })
          .validate({
            account,
            captcha,
            password
          });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      if (!that.spread)
        return that.$dialog.toast({
          mes: "请填写邀请码!"
        });
      register({
        account: that.account,
        captcha: that.captcha,
        password: that.password,
        spread: that.spread
      })
        .then(res => {
          that.$dialog.success(res.msg);
          that.current = 0;
          that.formItem = 1;
        })
        .catch(res => {
          that.onSmsCaptcha();
          that.$dialog.error(res.msg);
        });
    },
    async code() {
      var that = this;
      const { account } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({
            account
          });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      if (that.formItem == 2) that.type = "register";
      await registerVerify({
        phone: that.account,
        type: that.type,
        key: that.keyCode,
        code: that.codeVal
      })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          if (res.data.status === 402) {
            that.codeUrl = `${VUE_APP_API_URL}/sms_captcha?key=${that.keyCode}`;
            that.isShowCode = true;
          }
          that.$dialog.error(res.msg);
        });
    },
    navTap: function(index) {
      this.current = index;
    },
    async submit() {
      const { account, password, codeVal, wxcode } = this;
      try {
        await this.$validator({
          account: [
            required(required.message("账号")),
            attrs.range([5, 16], attrs.range.message("账号")),
            alpha_num(alpha_num.message("账号"))
          ],
          password: [
            required(required.message("密码")),
            attrs.range([6, 16], attrs.range.message("密码")),
            alpha_num(alpha_num.message("密码"))
          ],
          codeVal: this.isShowCode
            ? [
                required(required.message("验证码")),
                attrs.length(4, attrs.length.message("验证码")),
                alpha_num(alpha_num.message("验证码"))
              ]
            : []
        }).validate({
          account,
          password,
          codeVal
        });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      login(wxcode, {
        account,
        password,
        code: codeVal
      })
        .then(({ data }) => {
          let expires_time = data.expires_time.substring(0, 19);
          expires_time = expires_time.replace(/-/g, "/");
          expires_time = new Date(expires_time).getTime() - 28800000;
          const datas = {
            token: data.token,
            expires_time: expires_time
          };
          this.$store.commit("LOGIN", datas);
          const backUrl = cookie.get(BACK_URL) || "/";
          cookie.remove(BACK_URL);
          this.$router.replace({
            path: backUrl
          });
        })
        .catch(e => {
          this.$dialog.error(e.msg);
        });
    }
  }
};
</script>
<style scoped lang="scss">
.code img {
  width: 100%;
  height: 100%;
}

.logo_title {
  width: 100%;
  height: 100px;
  font-size: 19px;
  font-weight: bold;
  color: #000;
  text-align: center;
  padding: 35px 50px 17px 0;
}

.som {
  border-bottom: 2px solid #ff214b;
  color: #000 !important;
}

.item_name {
  font-size: 15px;
  font-weight: bold;
  color: rgb(98, 105, 118);
  margin-left: 5px;
}

.inp_box {
  margin-top: 10px;
  background-color: #f8f8f8;
  border-radius: 17px;
  padding: 8px 15px;
}
.inp_img {
  margin-top: 10px;
  background-color: #f8f8f8;
  border-radius: 17px;
  padding-left: 15px;
  overflow: hidden;
}
.register .whiteBg .list .item .code {
  position: relative;
  background-color: #f8f8f8;
  color: #25a984;
  text-align: center;
  font-size: 12px;
  white-space: nowrap;
  flex-shrink: 0;

  &::after {
    content: "";
    position: absolute;
    top: 0px;
    left: -18px;
    width: 2px;
    height: 15px;
    background-color: #25a984;
  }
}
.code_img {
  width: 100px;
  height: 40px;
  margin-left: 10px;
  background-color: #666;
}
</style>
